export default {
    email:  /^[\w\d._%+-]+@[\w\d.-]+\.[\w]{2,}$/,
    phone: /^\([\d]{2}\)[\s][\d]{4,5}-[\d]{4}$/,
    zipcode: /^[\d]{5}-[\d]{3}$/ 
}